import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { bookEditions } from "../data/bookEditions";
import BookSymbol from "./BookSymbol";
import "../trilogy-navigation.css";

export default function TrilogyNavigation({ mobileMenuOpen }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const triggerRef = useRef(null);
  const pendingFocus = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    pendingFocus.current = null;
  }, [location.key, mobileMenuOpen]);

  useEffect(() => {
    if (!open) return undefined;
    if (pendingFocus.current) {
      const links = containerRef.current.querySelectorAll(".trilogy-navigation__book");
      (pendingFocus.current === "last" ? links[links.length - 1] : links[0])?.focus();
      pendingFocus.current = null;
    }
    function closeOutside(event) {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    }
    document.addEventListener("pointerdown", closeOutside);
    return () => document.removeEventListener("pointerdown", closeOutside);
  }, [open]);

  function handleKeyDown(event) {
    if (event.key === "Escape" && open) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(false);
      triggerRef.current?.focus();
    }
    if (event.target === triggerRef.current && ["ArrowDown", "ArrowUp"].includes(event.key)) {
      event.preventDefault();
      const last = event.key === "ArrowUp";
      if (open) {
        const links = containerRef.current.querySelectorAll(".trilogy-navigation__book");
        (last ? links[links.length - 1] : links[0])?.focus();
      } else {
        pendingFocus.current = last ? "last" : "first";
        setOpen(true);
      }
    }
  }

  return (
    <div
      ref={containerRef}
      className="trilogy-navigation"
      data-open={open}
      onKeyDown={handleKeyDown}
      onPointerEnter={(event) => {
        if (event.pointerType === "mouse" && window.matchMedia("(min-width: 961px) and (hover: hover)").matches) setOpen(true);
      }}
      onPointerLeave={() => {
        if (!containerRef.current?.contains(document.activeElement)) setOpen(false);
      }}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
      }}
    >
      <button ref={triggerRef} type="button" className="trilogy-navigation__trigger" aria-expanded={open} aria-controls="trilogy-navigation-books" onClick={() => setOpen((current) => !current)}>
        <span className="trilogy-navigation__label">The trilogy</span>
        <svg className="trilogy-navigation__chevron" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1L5 5L9 1" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>
      <div id="trilogy-navigation-books" className="trilogy-navigation__panel" hidden={!open}>
        <ul className="trilogy-navigation__list">
          {bookEditions.map((book, index) => (
            <li key={book.slug}>
              <Link className={`trilogy-navigation__book trilogy-navigation__book--${index + 1}`} to={`/books/${book.slug}`} onClick={() => setOpen(false)} aria-current={location.pathname === `/books/${book.slug}` ? "page" : undefined}>
                <BookSymbol number={index + 1} />
                <span><span className="trilogy-navigation__number">Book {book.number}</span><span className="trilogy-navigation__title">{book.title}</span></span>
                <span className="trilogy-navigation__arrow" aria-hidden="true">→</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
